module.exports = __webpack_public_path__ + "img/019-half-moon.0af06313.svg";